import { ReactComponent as ProfileFillIconSvg } from '../../../icons/profile.fill.svg';

type ProfileAvatarProps = {
  thumbnailUrl?: string | null;
  widthAndHeight?: string;
  svgWidthAndHeight?: string;
  onClick?: () => void;
} & Record<string, unknown>;

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  thumbnailUrl,
  widthAndHeight = '24px',
  svgWidthAndHeight = '24px',
  onClick,
  ...props
}) => {
  if (thumbnailUrl) {
    return (
      <button
        type="button"
        style={{
          width: widthAndHeight,
          height: widthAndHeight,
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer'
        }}
        className="rounded-full overflow-hidden"
        onClick={onClick}
      >
        <img
          src={thumbnailUrl}
          alt=""
          className="w-full h-full rounded-full object-cover"
          style={{ width: widthAndHeight, height: widthAndHeight }}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      className="bg-theirty-light dark:bg-theirty-dark rounded-full flex items-center justify-center cursor-pointer"
      style={{
        width: widthAndHeight,
        height: widthAndHeight,
        padding: '5px',
        border: 'none',
        ...props
      }}
      onClick={onClick}
    >
      <ProfileFillIconSvg
        className="fill-white"
        width={svgWidthAndHeight}
        height={svgWidthAndHeight}
      />
    </button>
  );
};

export default ProfileAvatar;
